import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';

interface PromptPreviewProps {
    prompt: string | { system: string; userTemplate: string };
}

export const PromptPreview: React.FC<PromptPreviewProps> = ({ prompt }) => {
    const isObjectPrompt = typeof prompt === 'object';
    const systemPrompt = isObjectPrompt ? prompt.system : '';
    const userPrompt = isObjectPrompt ? prompt.userTemplate : prompt;

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 2, }}>
            <Typography variant="h6">Prompt Preview</Typography>

            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', mb: 3 }}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    {isObjectPrompt ? 'User Template' : 'Prompt'}
                </Typography>
                <Paper
                    sx={{
                        flex: 1,
                        p: 3,
                        bgcolor: '#f8f9fa',
                        overflow: 'auto',
                        fontFamily: 'monospace',
                        fontSize: '0.875rem',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        border: '1px solid',
                        borderColor: 'divider',
                        mb: 3
                    }}
                >
                    {userPrompt || 'No prompt to preview. Please create or select a prompt in the Refine tab.'}
                </Paper>
            </Box>
        </Box>
    );
};
